import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { addPortAPI, deletePortAPI, getPortAPI, getPortDetailAPI, updatePortAPI } from './api';
import {
  filterPort,
  filterPortSuccess,
  filterPortFailure,
  getDetailPort,
  getDetailPortSuccess,
  getDetailPortFailure,
  registerPortSuccess,
  registerPortFailure,
  registerPort,
  updatePortSuccess,
  updatePortFailure,
  deletePortSuccess,
  deletePortFailure,
  updatePort,
  deletePort,
} from './slice';
import {
  DeletePortMasterRequest,
  DetailPortMasterRequest,
  SearchPortMasterRequest,
  UpdatePortMasterRequest,
} from 'api-types/src/types/port-master';

function* fetchPortMaster({ payload }: { payload: SearchPortMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getPortAPI, trimQueryData(payload));
    yield put(filterPortSuccess(response.data));
  } catch (error) {
    yield put(filterPortFailure());
  }
}

function* fetchPortDetail({ payload }: { payload: DetailPortMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getPortDetailAPI, payload);
    yield put(getDetailPortSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailPortFailure({ message: error?.message }));
  }
}

function* registerPortSaga({ payload }: { payload: UpdatePortMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addPortAPI, payload);
    yield put(registerPortSuccess(response));
  } catch (error: any) {
    yield put(registerPortFailure({ message: error?.message }));
  }
}

function* updatePortSaga({ payload }: { payload: UpdatePortMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updatePortAPI, payload);
    yield put(updatePortSuccess(response));
  } catch (error: any) {
    yield put(updatePortFailure({ message: error?.message }));
  }
}

function* deletePortSaga({ payload }: { payload: DeletePortMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deletePortAPI, payload);
    yield put(deletePortSuccess(response));
  } catch (error: any) {
    yield put(deletePortFailure({ message: error?.message }));
  }
}

function* watchPortMaster() {
  yield takeLatest(filterPort, fetchPortMaster);
  yield takeLatest(getDetailPort, fetchPortDetail);
  yield takeLatest(registerPort, registerPortSaga);
  yield takeLatest(updatePort, updatePortSaga);
  yield takeLatest(deletePort, deletePortSaga);
}

export default watchPortMaster;
